import StoryModule from '../components/StoryModule';

const Callback = () => <StoryModule slug="callback" />;

export default Callback;
